import React, { Dispatch, SetStateAction, useMemo, useState } from "react";
import {
  Control,
  Controller,
  FieldErrors,
  UseFormHandleSubmit,
} from "react-hook-form";
import TextInput from "../inputs/TextInput";
import CustomTabs from "../tabs";
import RichTextEditor from "../richTextEditor";
import Loader from "../loader";
import { Button } from "../button";
import { useTranslation } from "react-i18next";

interface EmailTemplateCardProps {
  isEmailTemplateLoading: boolean;
  isAddUpdateEmailTemplateLoading: boolean;
  handleSubmit: UseFormHandleSubmit<
    {
      subject: string;
    },
    undefined
  >;
  onSubmit: (data: { subject: string }) => Promise<void>;
  control: Control<
    {
      subject: string;
    },
    any
  >;
  errors: FieldErrors<{
    subject: string;
  }>;
  htmlContent: string;
  setHtmlContent: Dispatch<SetStateAction<string>>;
}

const EmailTemplateCard = ({
  isEmailTemplateLoading,
  isAddUpdateEmailTemplateLoading,
  handleSubmit,
  onSubmit,
  control,
  errors,
  htmlContent,
  setHtmlContent,
}: EmailTemplateCardProps) => {
  const [tabIndex, setTabIndex] = useState(0);

  const { t } = useTranslation();

  const tabs = useMemo(
    () => [
      {
        id: 1,
        title: t("design"),
      },
      {
        id: 3,
        title: t("preview"),
      },
    ],
    [t]
  );

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="bg-white p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]"
    >
      <Controller
        name="subject"
        control={control}
        render={({ field: { onChange, name, value } }) => (
          <TextInput
            label={t("subject")}
            value={value}
            onChange={onChange}
            error={errors?.[name]?.message}
            required
          />
        )}
      />

      <div className="flex flex-col gap-4">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 md:gap-2">
          <CustomTabs
            tabs={tabs}
            tabIndex={tabIndex}
            setTabIndex={setTabIndex}
          />
        </div>

        {isEmailTemplateLoading ? (
          <div className="flex justify-center">
            <Loader />
          </div>
        ) : tabIndex === 0 ? (
          <RichTextEditor
            htmlContent={htmlContent}
            setHtmlContent={setHtmlContent}
          />
        ) : (
          <div
            style={{
              padding: "10px",
              border: "1px solid #ddd",
              borderRadius: "5px",
            }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        )}
      </div>

      <div>
        <Button isLoading={isAddUpdateEmailTemplateLoading}>{t("save")}</Button>
      </div>
    </form>
  );
};

export default React.memo(EmailTemplateCard);
